export default __webpack_public_path__ + "static/media/wuLogo.0748e596.png";